import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

//STYLES
import styles from '@UILayer/UILayer.scss';

// MANAGERS
import { getAuthenticateGameConfig, getGlobalStyles, getNumberOfReels, getNumberOfSymbolsPerReel } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// WINLINE IMAGE
import WinlineItem from './Winlines.item';
import WinlineItemPowerLine from './Winlines.item.powerLine';

const Winlines: React.FC<{}> = () => {
    const [state, setState] = useReducer(
        (
            state: {
                reelsData: Array<Array<number>>;
                noSymbolePerReel: number;
                noOfReels: number;
                powerLines: boolean;
            },
            newState: any
        ) => ({ ...state, ...newState }),
        { reelsData: [], noSymbolePerReel: 0, noOfReels: 0, powerLines: false }
    );

    const { t } = useTranslation();
    const gameStoreAuthenticateGameConfig = useAppSelector(getAuthenticateGameConfig);
    const gameStoreNumberOfSymbolsPerReel = useAppSelector(getNumberOfSymbolsPerReel);
    const gameStoreNumberOfReels = useAppSelector(getNumberOfReels);
    const globalStyles = useAppSelector(getGlobalStyles);
    const containerCN = cn(
        styles.settings_content_winlines,
        globalStyles.orientation,
        globalStyles.handMode,
        globalStyles.device,
        globalStyles.wcaMode,
        globalStyles.wideDevice,
        state.powerLines ? styles.powerLines : false,
        !state.powerLines ? styles.normalWinlines : false
    );

    useEffect(() => {
        const reelsData = gameStoreAuthenticateGameConfig.payLines;

        if (reelsData) {
            setState({
                reelsData: reelsData.map((reel) => reel.map((symbol) => symbol + 1)),
                noOfReels: gameStoreNumberOfReels,
                noSymbolePerReel: gameStoreNumberOfSymbolsPerReel,
                powerLines: gameStoreAuthenticateGameConfig.powerLines
            });
        }
    }, [gameStoreAuthenticateGameConfig, gameStoreNumberOfSymbolsPerReel, gameStoreNumberOfReels]);

    return (
        <div className={containerCN}>
            {state.powerLines ? (
                <WinlineItemPowerLine reelsNo={state.noOfReels} />
            ) : (
                <>
                    {(state.noOfReels === 3 || state.noOfReels === 5 || state.noOfReels === 6) && (
                        <>
                            {state.reelsData.map((element: any, index: number) => (
                                <div
                                    key={`winline_${index}`}
                                    className={styles.winlines_item}
                                    tabIndex={0}
                                    aria-description={`${t('WCA_WINLINE_ORDER_INFORMATION')}, ${index + 1} - ${element.toString()} `}
                                >
                                    <WinlineItem pos={element} index={index} type={state.noOfReels} rowNo={state.noSymbolePerReel} />
                                </div>
                            ))}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default Winlines;
